export default __webpack_public_path__ + "static/media/background-roomOverview.9968a36f.svg";